/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CompanyEmployeeInviteCreateDto,
  CompanyEmployeeInviteCreateDtoFromJSON,
  CompanyEmployeeInviteCreateDtoFromJSONTyped,
  CompanyEmployeeInviteCreateDtoToJSON,
} from "./CompanyEmployeeInviteCreateDto";

/**
 *
 * @export
 * @interface CompanyEmployeeInviteGroupCreateDto
 */
export interface CompanyEmployeeInviteGroupCreateDto {
  /**
   *
   * @type {Array<CompanyEmployeeInviteCreateDto>}
   * @memberof CompanyEmployeeInviteGroupCreateDto
   */
  invites: Array<CompanyEmployeeInviteCreateDto>;
}

export function CompanyEmployeeInviteGroupCreateDtoFromJSON(json: any): CompanyEmployeeInviteGroupCreateDto {
  return CompanyEmployeeInviteGroupCreateDtoFromJSONTyped(json, false);
}

export function CompanyEmployeeInviteGroupCreateDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyEmployeeInviteGroupCreateDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    invites: (json["invites"] as Array<any>).map(CompanyEmployeeInviteCreateDtoFromJSON),
  };
}

export function CompanyEmployeeInviteGroupCreateDtoToJSON(value?: CompanyEmployeeInviteGroupCreateDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    invites: (value.invites as Array<any>).map(CompanyEmployeeInviteCreateDtoToJSON),
  };
}
